import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { SharedService } from 'src/app/services/shared.service';
import { GenerateStripeElementComponent } from 'src/app/shared/generate-stripe-element/generate-stripe-element.component';

@Component({
    selector: 'app-add-card',
    templateUrl: './add-card.component.html',
    styleUrl: './add-card.component.scss',
})
export class AddCardComponent implements OnInit, OnDestroy {

  businessCode = '';
  currentYear = new Date().getFullYear();

  readonly businessDetails = signal<any>({});

  readonly loadingBusinessDetails = signal(false);
  readonly cardAdded = signal(false);
  readonly card_already_added = signal(false);
  readonly creatingIntent = signal(false);
  private modalRef?: BsModalRef<GenerateStripeElementComponent>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    public _shared: SharedService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.businessCode = this.route.snapshot.paramMap.get('code') || this.route.snapshot.queryParamMap.get('code') || '';
    const status = this.route.snapshot.queryParamMap.get('status') || '';
    this.cardAdded.set(status === 'success' || status === '1' || status === 'added');

    this.getBusinessDetails();
  }

  ngOnDestroy(): void {
    this.modalRef?.hide();
  }

  getBusinessDetails() {
    if (!this.businessCode) {
      return;
    }
    this.loadingBusinessDetails.set(true);
    this.api.api({ code: this.businessCode }, 'auth/get_business_details', 'get').subscribe({
      next: (response: any) => {
        this.loadingBusinessDetails.set(false);
        if (response && !response.is_error) {
          
          this.businessDetails.set(response.data);
          if (this.businessDetails().source_id) {
            this.card_already_added.set(true);
            //  this.shared.customPopups('Your card is already added.', 2);
          }else{
             this.card_already_added.set(false);
          }
        }
      },
      error: () => {
        this.loadingBusinessDetails.set(false);
      }
    });
  }

  openAddCardForm() {
    if (this.creatingIntent()) {
      return;
    }
    this.addCardModal()
  }
 addCardModal() {
    const modalRef = this.modalService.show(GenerateStripeElementComponent, {
      initialState: {
        stripeData: {
          doctor_profile: this.businessDetails(),
          payment_source_type: this._shared.paymentSourceType.CARD,
          payment_mode: this._shared.paymentMode.BUSINESS,
          action_from: 'BUSINESS_CARD',
          minHeight: 600,
          fromOpenPage: true
        }
      }
    })

    modalRef.content?.sendPaymentSourceData.subscribe((response) => {
      if (response.success) {
        this.cardAdded.set(true);
        this._shared.customPopups('Card added successfully', 0);
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { status: 'success' },
          queryParamsHandling: 'merge'
        });
      }
    })
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }

}
